// Link
import { Link as ChakraLink, type LinkProps as ChakraLinkProps } from '@chakra-ui/react';
import { Translation } from './translation';

// Link component with translation support
export interface LinkProps extends ChakraLinkProps {
  path?: string;
}

export const Link = ({ path, children, ...props }: LinkProps) => {
  return (
    <Translation path={path} children={children} render={(content) => <ChakraLink {...props}>{content}</ChakraLink>} />
  );
};
